function scrollToRelatedColors(){
  var headerHeight = $('.layout-2.bottom-header').outerHeight();
  $('html, body').animate({ scrollTop: $('#related_colors').offset().top - headerHeight }, 'slow');
}
function addDropIcon(){
  var filterLabels = document.querySelectorAll('.boost-pfs-filter-option-title');
  if(filterLabels.length > 0){
    for(i = 0; i < filterLabels.length; i++){
      filterLabels[i].classList.add("fa");
      filterLabels[i].classList.add("fa-angle-right");
    }
  }
}
window.addEventListener('load', addDropIcon, false);

$(document).ready(function(){
  if ($('.video-product')) {
    $('.video-product').each((index) => {
      $('.video-product').get(index).play();
    });
  }

  try{
    var getvars = [];
    location.search.replace('?', '').split('&').forEach(function (val) {
      split = val.split("=", 2);
      getvars[split[0]] = split[1];
    });

    if(getvars["contact_posted"] == "true" && jQuery( "[data-target='#myModal_trystore']" ) && $('.template-product')){
      jQuery( "[data-target='#myModal_trystore']" ).click();
    }

    if(getvars["contact_posted"] == "true" || getvars["getnotified"] == "true"){
      if(jQuery( "[data-target='#myModal_notify']" ) && $('.template-product')){
        jQuery( "[data-target='#myModal_notify']" ).click();
      }
    }
    if(getvars["customer_posted"]){
      if(getvars["customer_posted"].indexOf("true") !== -1 ){
        var headerHeight = $('.layout-2.bottom-header').outerHeight();
        $('html, body').animate({ scrollTop: $('#shopify-section-footer_ella_v').offset().top - headerHeight }, 'slow');
      }
    }

  }
  catch(err){
    console.log("La modale non è stata aperta perché: "+err.message);
  }

  /* Adding privacy checkbox to product reviews */

  function togglePrivacyDisplay(){
    if($('.spr-form').css('display') == 'none'){
      $('.review-privacy-label').hide();
    }else{
      $('.review-privacy-label').show();
      $('.review-privacy-label').insertAfter($('.spr-form-review'));
    }
  }

  function checkPrivacy(){
    let checkbox = $('input[name="review-checkbox"]');
    if(!checkbox.prop('checked')){
      return false;
    }else{
      return true;
    }
  }

  let panel_vertical = $('.panel.rte');

  panel_vertical.on('click', $('.spr-button-primary[type="submit"]'), function(){
    $('.spr-button-primary[type="submit"]').click(function(event){
      event.preventDefault();
      var is_checked = checkPrivacy();
      if(is_checked === true){
        $('.new-review-form').submit();
        setTimeout(function(){if ($('.spr-form-message-success')) {
          $('.review-privacy-label').hide();
        }}, 200)
      }else{
        $('.review-privacy-label').addClass('sh-review-error');
      }
    })
  });


  panel_vertical.on('click', $('.spr-summary-actions-newreview'), function(){
    togglePrivacyDisplay();
    $('.spr-summary-actions-newreview').click(function(){
      togglePrivacyDisplay();
    } )
  } )

  function audioPlayer(){
    let video = $('.eye-category-video video');
    $('.eye-category-video .audio-player').click(function(){
      if($('.eye-category-video-wrapper').hasClass('muted')){
        video[0].muted = false;
        $('.eye-category-video-wrapper').removeClass('muted');
      }else{
        video[0].muted = true;
        $('.eye-category-video-wrapper').addClass('muted');
      }
    })
  }audioPlayer();
});
